import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ManagerFormValuesProps} from "../components/shopManagers/NewShopManagerModal";
import {BlackoutDateProps} from "../types/BlackoutPeriod";

export const getCampaignMessagesLog = async (domain: string, campaignId: number): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `campaigns/${campaignId}/messages-log`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain,
    });
}